export interface PagedResult<T> {
  items: T[];
  total: number;
  page: number;
  pageSize: number;
}

export interface PaginationControls {
  /** 1-based current page */
  page: number;
  /** Reset the internal page counter to 1 (e.g. after a search query change). */
  reset(): void;
  /** Render Prev/Next + "Page X of Y" against the given DOM ids. */
  render(prevId: string, nextId: string, infoId: string, containerId: string, total: number, pageSize: number): void;
  /** Wire click handlers; `onChange` is called with the new page after a successful nav click. */
  attach(prevId: string, nextId: string, onChange: (page: number) => void): void;
}

export function createPagination(initialPage = 1): PaginationControls {
  let current = initialPage;
  let totalPages = 1;

  function render(prevId: string, nextId: string, infoId: string, containerId: string, total: number, pageSize: number): void {
    totalPages = Math.max(1, Math.ceil(total / pageSize));
    current = Math.min(current, totalPages);

    const container = document.getElementById(containerId);
    if (container) container.hidden = total === 0;

    const info = document.getElementById(infoId);
    if (info) info.textContent = total === 0 ? '' : `Page ${current} of ${totalPages} (${total} total)`;

    const prev = document.getElementById(prevId) as HTMLButtonElement | null;
    const next = document.getElementById(nextId) as HTMLButtonElement | null;
    if (prev) prev.disabled = current <= 1;
    if (next) next.disabled = current >= totalPages;
  }

  function reset(): void {
    current = 1;
  }

  function attach(prevId: string, nextId: string, onChange: (page: number) => void): void {
    document.getElementById(prevId)?.addEventListener('click', () => {
      if (current > 1) {
        current--;
        onChange(current);
      }
    });
    document.getElementById(nextId)?.addEventListener('click', () => {
      if (current < totalPages) {
        current++;
        onChange(current);
      }
    });
  }

  return {
    get page() { return current; },
    reset,
    render,
    attach,
  };
}
